var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83325 7.5V0.53125C8.83325 0.25 9.02075 0 9.33325 0C13.177 0 16.3333 3.15625 16.3333 7C16.3333 7.28125 16.0833 7.5 15.802 7.5H8.83325ZM14.7395 6C14.302 3.78125 12.552 2.03125 10.3333 1.59375V6H14.7395ZM7.33325 1.5625V9L12.2083 13.9062C12.427 14.125 12.3958 14.4688 12.177 14.625C10.927 15.5 9.427 16 7.83325 16C3.677 16 0.333252 12.6562 0.333252 8.5C0.333252 4.71875 3.14575 1.59375 6.77075 1.09375C7.08325 1.03125 7.33325 1.28125 7.33325 1.5625ZM5.83325 9.625V2.84375C3.4895 3.6875 1.83325 5.90625 1.83325 8.5C1.83325 11.8125 4.4895 14.5 7.83325 14.5C8.677 14.5 9.45825 14.3438 10.2083 14.0312L5.83325 9.625ZM16.7708 9C17.052 9 17.302 9.25 17.2395 9.53125C17.0208 11.2812 16.177 12.8438 14.927 14C14.7395 14.1562 14.4583 14.1562 14.2708 13.9688L9.33325 9H16.7708Z",
    fill: "#58595B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioBlackIcon);
export default __webpack_public_path__ + "static/media/portfolio-black-icon.3a0a61bfdc20b1ae08a19a0908737dc9.svg";
export { ForwardRef as ReactComponent };